module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addClient":"Add Client"},"fr":{"addClient":"Ajouter un client"}}')
  delete Component.options._Ctor
}
